import { render } from "./djRecharge.vue?vue&type=template&id=15e6e5de&scoped=true"
import script from "./djRecharge.vue?vue&type=script&lang=js"
export * from "./djRecharge.vue?vue&type=script&lang=js"

import "./djRecharge.vue?vue&type=style&index=0&id=15e6e5de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15e6e5de"

export default script